// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.102.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.102.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.102.1/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/imgs/grid.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("assets/imgs/menu_bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menuLayer__X5sIrxoDMz {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: black;
  z-index: 110;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center / cover, url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center center / cover;
  overflow-y: auto;
  padding-bottom: 0.5rem;
  overflow-x: hidden;
}
.menuLayerContent__P5J0g8CalC {
  width: 12.5rem;
  margin: 0 auto;
  margin-top: 0.8rem;
  padding-left: 1.2rem;
}
.menuItem__koGAcfO1Go {
  margin-bottom: 0.3rem;
  width: 100%;
}
.menuItem__koGAcfO1Go:last-child {
  margin-bottom: 0;
}
.menuItem__koGAcfO1Go .ant-image {
  opacity: 0;
  transition: all 0.15s ease;
  transform: translateX(-1.5rem);
}
.menuItem__koGAcfO1Go.active__ghoMm7oJL8 .ant-image,
.menuItem__koGAcfO1Go:hover .ant-image {
  opacity: 1;
  transform: translateX(0);
}
.menuItem__koGAcfO1Go h2 {
  color: #e9e9d7;
  margin: 0;
  margin-left: 0.42rem;
  font-size: 0.5rem;
  transition: color 0.1s ease-in-out;
  cursor: pointer;
}
.menuItem__koGAcfO1Go h2.orange__YXwPEwX9_X.active__ghoMm7oJL8,
.menuItem__koGAcfO1Go h2.orange__YXwPEwX9_X:hover {
  color: #ffb417;
}
.menuItem__koGAcfO1Go h2.cyan__D91AkCiipi.active__ghoMm7oJL8,
.menuItem__koGAcfO1Go h2.cyan__D91AkCiipi:hover {
  color: #00ffff;
}
.menuItem__koGAcfO1Go h2.green__IsGJlQrs69.active__ghoMm7oJL8,
.menuItem__koGAcfO1Go h2.green__IsGJlQrs69:hover {
  color: #8afd25;
}
.menuItem__koGAcfO1Go h2.yellow__p2yAJrkTIW.active__ghoMm7oJL8,
.menuItem__koGAcfO1Go h2.yellow__p2yAJrkTIW:hover {
  color: #fef038;
}
.menuItem__koGAcfO1Go h2.red__ZPSzSuwH_b.active__ghoMm7oJL8,
.menuItem__koGAcfO1Go h2.red__ZPSzSuwH_b:hover {
  color: #ff514f;
}
.menuItem__koGAcfO1Go h2.purple__m3vaPBNi6L.active__ghoMm7oJL8,
.menuItem__koGAcfO1Go h2.purple__m3vaPBNi6L:hover {
  color: #ff46ff;
}
`, "",{"version":3,"sources":["webpack://./src/components/MenuLayer/index.module.less"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,4JAAA;EAGA,gBAAA;EACA,sBAAA;EACA,kBAAA;AAHF;AAMA;EACE,cAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;AAJF;AAOA;EACE,qBAAA;EACA,WAAA;AALF;AAOE;EACE,gBAAA;AALJ;AAAA;EASI,UAAA;EACA,0BAAA;EACA,8BAAA;AANJ;AASE;;EAGI,UAAA;EACA,wBAAA;AARN;AAVA;EAuBI,cAAA;EACA,SAAA;EACA,oBAAA;EACA,iBAAA;EAEA,kCAAA;EACA,eAAA;AAXJ;AAcM;;EAEE,cAAA;AAZR;AAiBM;;EAEE,cAAA;AAfR;AAoBM;;EAEE,cAAA;AAlBR;AAuBM;;EAEE,cAAA;AArBR;AA0BM;;EAEE,cAAA;AAxBR;AA6BM;;EAEE,cAAA;AA3BR","sourcesContent":["@import 'assets/styles/variables.less';\n\n.menuLayer {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: black;\n  z-index: 110;\n  background: url('assets/imgs/grid.png') no-repeat center center / cover,\n    url('assets/imgs/menu_bg.png') no-repeat center center / cover;\n\n  overflow-y: auto;\n  padding-bottom: 0.5rem;\n  overflow-x: hidden;\n}\n\n.menuLayerContent {\n  width: 12.5rem;\n  margin: 0 auto;\n  margin-top: 0.8rem;\n  padding-left: 1.2rem;\n}\n\n.menuItem {\n  margin-bottom: 0.3rem;\n  width: 100%;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  :global(.ant-image) {\n    opacity: 0;\n    transition: all 0.15s ease;\n    transform: translateX(-1.5rem);\n  }\n\n  &.active,\n  &:hover {\n    :global(.ant-image) {\n      opacity: 1;\n      transform: translateX(0);\n    }\n  }\n\n  h2 {\n    color: @color_white;\n    margin: 0;\n    margin-left: 0.42rem;\n    font-size: 0.5rem;\n    // line-height: 1em;\n    transition: color 0.1s ease-in-out;\n    cursor: pointer;\n\n    &.orange {\n      &.active,\n      &:hover {\n        color: #ffb417;\n      }\n    }\n\n    &.cyan {\n      &.active,\n      &:hover {\n        color: #00ffff;\n      }\n    }\n\n    &.green {\n      &.active,\n      &:hover {\n        color: #8afd25;\n      }\n    }\n\n    &.yellow {\n      &.active,\n      &:hover {\n        color: #fef038;\n      }\n    }\n\n    &.red {\n      &.active,\n      &:hover {\n        color: #ff514f;\n      }\n    }\n\n    &.purple {\n      &.active,\n      &:hover {\n        color: #ff46ff;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menuLayer": `menuLayer__X5sIrxoDMz`,
	"menuLayerContent": `menuLayerContent__P5J0g8CalC`,
	"menuItem": `menuItem__koGAcfO1Go`,
	"active": `active__ghoMm7oJL8`,
	"orange": `orange__YXwPEwX9_X`,
	"cyan": `cyan__D91AkCiipi`,
	"green": `green__IsGJlQrs69`,
	"yellow": `yellow__p2yAJrkTIW`,
	"red": `red__ZPSzSuwH_b`,
	"purple": `purple__m3vaPBNi6L`
};
export default ___CSS_LOADER_EXPORT___;
